import React from 'react';

import VisitorIdentitySummary from '../identity/VisitorIdentitySummary';
import type { IdentityStatus } from '../../lib/visitorIdentity';
import type { VisitorPresence } from './liveViewModel';

/**
 * Width cap for the identity text in the Visitors list "Visitor" column.
 *
 * The list table is auto-layout, so a `truncate` (nowrap) name with no bound
 * makes the cell as wide as the longest enriched company name, which pushes
 * the whole row past the viewport and hides the Actions column. The cap is
 * what makes the ellipsis actually happen (AIM-520).
 */
export const VISITOR_LIST_IDENTITY_MAX_WIDTH_CLASS = 'max-w-[200px]';

interface VisitorListIdentityCellProps {
  visitor: VisitorPresence;
  status: IdentityStatus;
  subtitle?: string | null;
  verifiedTitle?: string | null;
  /** The avatar is rendered by the caller; it stays fixed-width beside the text. */
  avatar: React.ReactNode;
}

const VisitorListIdentityCell: React.FC<VisitorListIdentityCellProps> = ({
  visitor,
  status,
  subtitle,
  verifiedTitle,
  avatar,
}) => (
  <div className="flex items-center gap-3">
    {avatar}
    <div className={`min-w-0 ${VISITOR_LIST_IDENTITY_MAX_WIDTH_CLASS}`}>
      <VisitorIdentitySummary
        status={status}
        lead={visitor.identity?.lead}
        person={visitor.identity?.person}
        company={visitor.identity?.company}
        subtitle={subtitle}
        verifiedTitle={verifiedTitle}
      />
      {visitor.human_agent && (
        <div className="text-xs text-muted-foreground truncate">
          Rep: {visitor.human_agent.name || visitor.human_agent.email}
        </div>
      )}
    </div>
  </div>
);

export default VisitorListIdentityCell;
